import { CompetitorType } from "../../events/entity";
var DancesSetType;
(function (DancesSetType) {
    DancesSetType[DancesSetType["Fixed"] = 0] = "Fixed";
    DancesSetType[DancesSetType["Reducable"] = 1] = "Reducable";
    DancesSetType[DancesSetType["Changeable"] = 2] = "Changeable";
})(DancesSetType || (DancesSetType = {}));
export { CompetitorType, DancesSetType, };
